var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCalls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.979,
    height: 14.652,
    viewBox: "0 0 21.979 14.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-video",
    "data-name": "Icon awesome-video",
    d: "M12.829,4.5h-11A1.824,1.824,0,0,0,0,6.324v11a1.824,1.824,0,0,0,1.824,1.824h11a1.824,1.824,0,0,0,1.824-1.824v-11A1.824,1.824,0,0,0,12.829,4.5Zm7.227,1.439L15.874,8.823v6.006l4.182,2.881a1.223,1.223,0,0,0,1.923-.984v-9.8A1.224,1.224,0,0,0,20.056,5.939Z",
    transform: "translate(0 -4.5)",
    fill: "#ea0f08"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCalls);
export default __webpack_public_path__ + "static/media/video_calls.5433bca6304f05bdbd33974dfc9ff969.svg";
export { ForwardRef as ReactComponent };